import React, { useContext, useState } from 'react'
import Slider from './Slider'
import CarouselTwoImageSlider from './CarouselTwoImageSlider'
import { CardContext } from '../../store/CardContext'
import BasicInfoSection from './BasicInfoSection'
import { IoMdClose } from 'react-icons/io'

function About() {

    const [activeTab, setActiveTab] = useState('tab1')
    const showTab = (tabId) => {
        // console.log(tabId);
        setActiveTab(tabId)
    }
    const [cardData] = useContext(CardContext)
    const {
        logo,
        aboutInfo1,
        aboutInfo2,
        devInitiative,
        colors,
        gallery,
    } = cardData

    const txtColor = colors?.txtColor ? colors?.txtColor : "black"
    const iconColor = colors?.iconColor ? colors?.iconColor : "black"
    const btnColor = colors?.btnColor ? colors?.btnColor : "black"
    const btnTxtColor = colors?.btnTxtColor ? colors?.btnTxtColor : "white"
    const bgColor = colors?.bgColor ? colors?.bgColor : "white"


    const [readMore, setReadMore] = useState(false);
    const [detailView, setDetailView] = useState(false);

    const handleReadMore = (item) => {
        setReadMore(!readMore);
        setDetailView(item)
    };

    const handleClose = () => {
        setReadMore(false);
        setDetailView("")
    };





    return (
        <div>
            <div className="about " style={{ color: txtColor }}>
                <div className="live_header w-full flex mx-auto py-5 justify-between items-center flex-shrink-0  shadow-md ">
                    <div className="live_header_logo flex justify-between items-center gap-2.5 mx-3">
                        <img className='w-10 h-10' src={logo} />
                        <p
                            className="text-center text-base font-semibold "
                            id="l-update"
                        >
                            About
                        </p>
                    </div>

                </div>
                {readMore ?
                    <div className='px-5'>
                        <div className='flex justify-between items-center mt-2 '>
                            <p className=" text-base font-semibold mt-8 mb-3  ">
                                {detailView?.headline}
                            </p>
                            <p className=' w-10 h-10 rounded-full flex justify-center items-center cursor-pointer'
                                onClick={handleClose}
                                style={{
                                    background: btnColor,
                                    color: btnTxtColor
                                }}
                            >
                                <IoMdClose />
                            </p>
                        </div>
                        {/* <img src={detailView?.url} alt="" srcset="" /> */}
                        {detailView?.url &&
                            <div>
                                {detailView?.type?.startsWith("video") ? (
                                    <video className="w-full h-full object-contain"
                                        // className=" w-full h-full"
                                        // width="400"
                                        // height="600px"
                                        controls
                                        src={detailView?.url}
                                    />
                                ) : detailView?.type?.startsWith("embed") ? (
                                    <iframe
                                        width="100%"
                                        height="100%"
                                        src={detailView?.url}
                                        title="YouTube video player"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                ) : (
                                    <img
                                        className="w-full h-full object-contain"
                                        src={detailView?.url}
                                        alt="Image"
                                    />
                                )}
                            </div>
                        }

                        <p className=" font-base text-sm mt-4">
                            {detailView.description}
                        </p>
                    </div>
                    :
                    <div className="about_details px-4">
                        <div className="flex items-center justify-center mb-5">
                            <div className="tab-container flex justify-around border-2  rounded-full w-full mx-2 mt-5">
                                <div
                                    className={`tab  text-center p-2 w-full rounded-l-full`}
                                    id="tab1button"
                                    style={{
                                        background: activeTab === 'tab1' && btnColor,
                                        color: activeTab === 'tab1' && btnTxtColor
                                    }}
                                    onClick={(e) => showTab('tab1')}
                                >
                                    {aboutInfo1?.buttonName}
                                </div>
                                <div
                                    className={`tabone  text-center p-2 w-full rounded-r-full`}
                                    id="tab2button"
                                    style={{
                                        background: activeTab === 'tab2' && btnColor,
                                        color: activeTab === 'tab2' && btnTxtColor
                                    }}
                                    onClick={(e) => showTab('tab2')}
                                >
                                    {aboutInfo2?.buttonName}
                                </div>
                            </div>
                        </div>
                        {activeTab === "tab1" &&
                            <div className="tab-content" id="tab1" >
                                <div>
                                    {aboutInfo1?.basicInfo?.heading &&
                                        <p className="font-semibold text-base mt-5  ">
                                            {aboutInfo1?.basicInfo?.heading}
                                        </p>
                                    }
                                    <BasicInfoSection itemDatas={aboutInfo1?.basicInfo?.contents} txtColor={txtColor} iconColor={iconColor} />
                                </div>

                                <div>
                                    {aboutInfo1?.linkedSection.map((item) => (

                                        <div className="Parliament_details">
                                            {item?.heading &&
                                                <p className=" text-base font-semibold mt-8 mb-3 ">
                                                    {item?.heading}
                                                </p>
                                            }

                                            <div className="p-4 rounded-xl shadow-xl border" >
                                                <p className=" font-semibold text-sm">
                                                    {item.headline}
                                                </p>
                                                <div className="mt-2 ">
                                                    <div className='flex'>
                                                        <p className={` font-normal text-sm ${readMore ? 'h-auto' : 'line-clamp-5'} overflow-hidden`} id="l-latest-dtl">
                                                            {item?.description}
                                                        </p>
                                                        {/* {readMore ?
                                                            ""
                                                            :
                                                            <p className='flex items-end' >...</p>
                                                        } */}
                                                    </div>
                                                    <p className="text-sm text-end font-semibold cursor-pointer mt-1" onClick={(e) => handleReadMore(item)} style={{ color: btnColor }} >
                                                        {readMore ? "View Less >" : "View More >"}
                                                    </p>
                                                </div>

                                            </div>

                                        </div>
                                    ))}


                                </div>
                            </div>
                        }
                        {activeTab === "tab2" &&
                            <div
                                className="tab-content"
                                id="tab2"
                            >
                                <div>

                                    {aboutInfo2?.basicInfo?.heading &&
                                        <p className="font-semibold text-base mt-5  ">
                                            {aboutInfo2?.basicInfo?.heading}
                                        </p>
                                    }
                                    <BasicInfoSection itemDatas={aboutInfo2?.basicInfo?.contents} txtColor={txtColor} iconColor={iconColor} />
                                </div>
                                <div className="mt-5">
                                    <p className="font-semibold text-base  mb-4 ">
                                        Development Initiative
                                    </p>
                                    {/* <CarouselTwoImageSlider images={devInitiative?.contents} /> */}
                                    <CarouselTwoImageSlider images={devInitiative?.contents} bgColor={bgColor} txtColor={txtColor} btnColor={btnColor} btnTxtColor={btnTxtColor} />
                                </div>

                                <div className="mt-10">
                                    <p className="font-semibold text-base  mb-4 ">
                                        Gallery
                                    </p>
                                    <Slider data={gallery?.images} />
                                </div>
                            </div>
                        }
                    </div>
                }

            </div>
        </div>
    )
}

export default About